import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tipForm"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "添加调度费", -1);
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "hint"
}, "调度费全部归司机所有，添加调度费可以提高接单率。", -1);
const _hoisted_5 = {
  class: "card quick-add"
};
const _hoisted_6 = {
  class: "amount-input"
};
const _hoisted_7 = {
  class: "button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_grid_item = _resolveComponent("van-grid-item");
  const _component_van_grid = _resolveComponent("van-grid");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_grid, {
    "column-num": 3,
    border: false,
    "icon-size": "32px"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/tip/tip-cup.png'),
      text: "5元",
      onClick: _cache[0] || (_cache[0] = $event => $data.inputAmount = 5)
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/tip/tip-drinks.png'),
      text: "10元",
      onClick: _cache[1] || (_cache[1] = $event => $data.inputAmount = 10)
    }, null, 8, ["icon"]), _createVNode(_component_van_grid_item, {
      icon: require('@/assets/icon/tip/tip-cake.png'),
      text: "20元",
      onClick: _cache[2] || (_cache[2] = $event => $data.inputAmount = 20)
    }, null, 8, ["icon"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" ￥ "), _createVNode(_component_van_field, {
    modelValue: $data.inputAmount,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.inputAmount = $event),
    type: "digit",
    placeholder: "请输入金额1-100元",
    onInput: $options.amountInput,
    maxlength: "3"
  }, null, 8, ["modelValue", "onInput"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_button, {
    color: "#ff8c00",
    block: "",
    plain: "",
    onClick: $options.cancelButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 不添加调度费 ")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_van_button, {
    color: "#ff9500",
    block: "",
    disabled: !($data.inputAmount && $data.inputAmount.length > 0),
    onClick: $options.enterButtonClick
  }, {
    default: _withCtx(() => [_createTextVNode(" 添加调度费" + _toDisplayString($data.inputAmount > 0 ? $data.inputAmount + "元" : ""), 1)]),
    _: 1
  }, 8, ["disabled", "onClick"])])])]);
}